import { useEffect, useRef, useState } from 'react'

const DAY_IN_MS = 24 * 60 * 60 * 1000

type Countdown = {
  hours: string
  minutes: string
  seconds: string
}

function format(value: number): string {
  return String(Math.max(value, 0)).padStart(2, '0')
}

export function useCountdown(durationMs: number = DAY_IN_MS): Countdown {
  const deadline = useRef(Date.now() + durationMs)
  const [remaining, setRemaining] = useState(durationMs)

  useEffect(() => {
    const tick = () => setRemaining(Math.max(deadline.current - Date.now(), 0))
    tick()
    const interval = window.setInterval(tick, 1000)
    return () => window.clearInterval(interval)
  }, [])

  const totalSeconds = Math.floor(remaining / 1000)

  return {
    hours: format(Math.floor(totalSeconds / 3600)),
    minutes: format(Math.floor((totalSeconds % 3600) / 60)),
    seconds: format(totalSeconds % 60),
  }
}
